<script>
	import ButtonViewsXpages from './componentes/ButtonViewsXpages.svelte';
	import Helper from './components/Helper.svelte';
  import { viewsXpages, registerXpage } from './stores/store.js'; // CAMBIO AGREGAR quitar duplicado  
  import BotonOrder from './componentes/BotonOrder.svelte'; // CAMBIO AGREGAR 
  import { fade, fly } from 'svelte/transition';
  import Input from './componentes/Forms/Input.svelte';
	import Modal from './components/Modal.svelte';  
  import { push } from 'svelte-spa-router';
  import AnimationContainer from './components/AnimationContainer.svelte';
  import Navbar from './components/Navbar.svelte';
  import Titlesection from "./components/Titlesection.svelte";
  import { autentificado, prefix, urlapi, login,miPermiso,iduser } from './stores/store';

  import DatagridRow from './componentes/DatagridRow.svelte';
  import DatagridTitle from './componentes/DatagridTitle.svelte';
  import DatagridCell from './componentes/DatagridCell.svelte';
  import Datagrid from './componentes/Datagrid.svelte';

  import Infopagination from './components/Infopagination.svelte';
  import Pagination from './components/Pagination.svelte';
  import Searchsection from "./components/Searchsection.svelte";
  import { object2array, postData, verifyAccess } from './scripts';

  //verifyAccess($login,$miPermiso,'clientes','access')

  /* PERMISOS */
  let viewPage=false;

  if($login===false)
  {
      push('/login')
  } else if( $miPermiso.clientes.access===false ) {
      push('/sinpermiso')
  } else {
      viewPage=true;
  }
  /* FIN PERMISOS */

  let avanzado=false;
  let uid=null; // CAMBIO AGREGAR VARIABLE
  const res=null;
  let datagrid=[]
  let cargando=false;
  let pageActual=0;
  let dataPagination={};
  let searchText='';
  let orderField='id';
  let orderDir='ASC';
  
  function eventPage(event)
  {
      pageActual=event.detail.text;
      loadData()
  }

  function eventSearch(event)
  {
      pageActual=0;
      searchText=event.detail.text
      loadData()
  }

  function eventText()
  {
      pageActual=0;
      loadData()
  }

  async function loadData()
  {
      cargando=true;

      let datos={ 
          'cmd': "clientes_list",
          pagination: $viewsXpages,
          page: pageActual,
          order: orderField,
          dir: orderDir }

      if(avanzado===true)
      {
          if(searchText!='') datos={...datos, 'search':searchText }
      }
      
      const res = await postData($urlapi, [datos])
      .then(data => {
          datagrid= object2array(data[0].result);
          dataPagination=data[0].pagination;
          cargando=false;
      });
      
  }

  let edit= function(id) { push('/cliente/'+id); }
  let nuevo=function () { push('/cliente/0')}
  let eliminar=function() {
        postData($urlapi, [{ 
            'cmd':'clientes_delete',
            'id':seleccionado,
        }]).then(data => {
            pageActual=0;
            loadData()
        });
  }

  function orderTable(event) {
        if(cargando===false) {
        pageActual=0;
        orderField=event.detail.order;
        orderDir=event.detail.dir;
        loadData()
        }
  }


  let helper=false;

  let seleccionado=false;
  let selected= function (event) { 
      if(seleccionado==false || seleccionado!==event.detail.id) {
        seleccionado=event.detail.id
      } else {
        seleccionado=false
      }
  }

</script>

{#if viewPage===true}

<Navbar />

<AnimationContainer>
    <Titlesection>
        <span slot="title"><i class="bi bi-person-square me-1" />Clientes</span>
        <span slot="toolbar">

          {#if $miPermiso.clientes.insert===true}
              <button class='btn btn-primary' on:click={nuevo} on:mouseenter={()=>helper='Crear Registro'} on:mouseleave={()=>helper=false}><i class="bi bi-plus-circle"></i></button>
          {/if}

          {#if $miPermiso.clientes.edit===true}
              <span on:mouseenter={()=>helper='Editar Registro'} on:mouseleave={()=>helper=false}><button disabled={!seleccionado} class='btn btn-success' on:click={()=>edit(seleccionado)}><i class="bi bi-pencil-square"></i></button></span>
          {/if}
          
          {#if $miPermiso.clientes.delete===true}
              <Modal classButton='btn-danger' iconButton='bi-trash' functionSi={eliminar} title='ADVERTENCIA' disabled={!seleccionado}  on:mouseenter={()=>helper='Eliminar Registro'} on:mouseleave={()=>helper=false}>
                Esta seguro que desea <strong>Eliminar</strong> el registro?<br/>Se perderán todos los datos.
              </Modal>
          {/if}

          {#if avanzado===false}
            <button class='btn btn-secondary' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
          {:else}
            <button class='btn btn-success' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
          {/if}

          <ButtonViewsXpages on:load={()=>{pageActual=0; loadData();}} on:mouseenter={()=>helper='Registros por página'} on:mouseleave={()=>helper=false}/>

          <BotonOrder uid={uid} on:mouseenter={()=>helper='Ordenar'} on:mouseleave={()=>helper=false} />
        </span>
    </Titlesection>

    {#if avanzado===true}
    <div class="container-fluid mt-1" in:fly={{y:-10,duration:500}}>
        <div class="row">

            <div class='col-12 mb-2 mt-2'>
                <Input label='Filtrar por ID, NOMBRE, APELLIDOS, NIT' bind:value={searchText} on:change={eventText} />
            </div>          
        </div>
    </div>
    {/if}

    <!-- DATA GRID -->
    <div class="container-fluid mt-2">
    <div class="row">
        <div class="col-12">

            <Datagrid bind:uid={uid} order={orderField} dir={orderDir} on:order={orderTable}>

                <svelte:fragment slot="header">
                    <DatagridTitle width='100px' order="id" title='ID'/>
                    <DatagridTitle order="nombre" title='Nombre'/>
                    <DatagridTitle width='100px' order="tipo_identificacion" title='Tipo'/>
                    <DatagridTitle width='150px' order="nit" title='NIT/DPI'/>
                </svelte:fragment>
                <svelte:fragment slot="body">
                {#each datagrid as item}
                <DatagridRow id={item.id} bind:seleccionado={seleccionado} on:select={selected}>
                        <DatagridCell title='ID'>{item.id}</DatagridCell>
                        <DatagridCell title='Nombre' primary>{item.nombre} {item.apellidos}</DatagridCell>
                        <DatagridCell title='Tipo'>{item.tipo_identificacion}</DatagridCell>
                        <DatagridCell title='Código'>{item.nit}</DatagridCell>
                </DatagridRow>
                {/each}
                
                </svelte:fragment>
            </Datagrid>

        </div>
    </div>
    </div>

    <!-- PAGINACIÓN -->
    <div class="container mt-3">
    <div class="row">
        <div class="col-12 col-md-6 text-end text-md-start">
        <Infopagination data={dataPagination}/>
        </div>
        <div class="col-12 col-md-6">
        <Pagination selected={pageActual} data={dataPagination} on:page={eventPage}/>
        </div>
    </div>
    </div>

    <Helper bind:text={helper}></Helper>

</AnimationContainer>

{/if}

<!-- <script>
      
	  import SearchCombo from './components/SearchCombo.svelte';
	    import Offcanvas from './components/Offcanvas.svelte';
      import Infopagination from './components/Infopagination.svelte';
      import Pagination from './components/Pagination.svelte';
      import Navbar from './components/Navbar.svelte';
  
      import { tabla_clientes } from './stores/tablas.js';
  
      import TableResponsive from './components/Table/TableResponsive.svelte';
      import Searchsection from "./components/Searchsection.svelte";
      import Titlesection from "./components/Titlesection.svelte";
      import { object2array, postData } from './scripts';
      import { autentificado, prefix, urlapi, viewsXpages } from './stores/store';
      import { push } from 'svelte-spa-router';
      import AnimationContainer from './components/AnimationContainer.svelte';
  


    let datagrid=[]
    let cargando=false;
    let pageActual=0;
    let dataPagination={};
    let searchText='';
    let searchRuta='';
    let rutas_clientes_combo=[{ id:'',text:'Seleccione Ruta'}];

    postData($urlapi + "rutas", {
        func: "list",
        token: localStorage.getItem($prefix + "_token"),
    }).then((data) => {
        rutas_clientes_combo=[...rutas_clientes_combo, ...object2array(data.result)]
    });

    loadData()

    function eventPage(event)
    {
        pageActual=event.detail.text;
        loadData()
    }
  
    function eventSearch(event)
    {
        pageActual=0;
        searchText=event.detail.text
        loadData()
    }
    function eventCombo(event)
    {
        pageActual=0;
        loadData()
    }
    
    function loadData()
    {
        cargando=true;
        postData($urlapi + "clientes", {
            func: "list",
            token: localStorage.getItem($prefix + "_token"),
            pagination: $viewsXpages,
            page: pageActual,
            search: searchText,
            searchRuta: searchRuta
        }).then((data) => {
              if(data.error===true)
              {
                  push(data.redirection)
              } else {
                  datagrid= object2array(data.result);
                  dataPagination=data.pagination;
                  cargando=false;
              }
        });
    }
  
    let edit= function(id) {  push('/clientes/'+id) }
    //if(!$autentificado) { push('/login')}
  </script>

{#if $autentificado}
<Navbar />

<AnimationContainer>

    <Titlesection>
        <span slot="title"><i class="bi {$tabla_clientes.icon} me-1" />{$tabla_clientes.name}</span>
    </Titlesection>

    <Searchsection on:change={eventSearch} search={searchText}/>

    <div class="container">
      <div class="row">
        <div class="col-12 col-md-6 text-end text-md-start mt-2">
          <SearchCombo on:change={eventCombo} bind:options={rutas_clientes_combo} bind:value={searchRuta} title='Rutas'/>
        </div>
      </div>
    </div>

    <div class="container mt-3">
        <div class="row">
          <div class="col-12 col-md-6 text-end text-md-start">
            <Infopagination data={dataPagination}/>
          </div>
          <div class="col-12 col-md-6">
            <Pagination selected={pageActual} data={dataPagination} on:page={eventPage}/>
          </div>
        </div>
    </div>

    <div class="container mt-3">
        <div class="row">
          <div class="col">

            <TableResponsive edit={edit} editText='Ver' editIcon='bi-person-bounding-box' struct={$tabla_clientes} data={datagrid} cargando={cargando}></TableResponsive>

          </div>
        </div>
    </div>
    
    <div class="container mt-3">
        <div class="row">
          <div class="col-12 col-md-6 text-end text-md-start">
            <Infopagination data={dataPagination}/>
          </div>
          <div class="col-12 col-md-6">
            <Pagination selected={pageActual} data={dataPagination} on:page={eventPage}/>
          </div>
        </div>
      </div>    

</AnimationContainer>
{/if} -->